import { APPEARANCES as ACTION_BUTTON_APPEARANCES } from '../../action-button/constants';
import { HEADING_APPEARANCES } from '../../heading/constants';
import { APPEARANCES } from '../constants';
const getAppearanceConfig = (appearance) => {
  switch (appearance) {
    case APPEARANCES.accent: {
      return {
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.accent,
        titleAppearance: HEADING_APPEARANCES.accent,
      };
    }

    case APPEARANCES.cta: {
      return {
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.cta,
        titleAppearance: HEADING_APPEARANCES.cta,
      };
    }

    case APPEARANCES.danger: {
      return {
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.danger,
        titleAppearance: HEADING_APPEARANCES.danger,
      };
    }

    case APPEARANCES.success: {
      return {
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.default,
        titleAppearance: HEADING_APPEARANCES.success,
      };
    }

    default: {
      return {
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.default,
        titleAppearance: HEADING_APPEARANCES.default,
      };
    }
  }
};

export default getAppearanceConfig;
